// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qdmJbW0up0s8Qr4AhzPa{align-items:center}.qdmJbW0up0s8Qr4AhzPa>input{height:32px;padding:0 8px;font-size:16px;font-style:normal;font-weight:500;line-height:150%}.qdmJbW0up0s8Qr4AhzPa.oZSKr1v2FrYCtJrBe0yF{padding-right:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `qdmJbW0up0s8Qr4AhzPa`,
	"error": `oZSKr1v2FrYCtJrBe0yF`
};
export default ___CSS_LOADER_EXPORT___;
